import { sanitizeFilename } from "../sanitizeFilename";

export function contentSimplifierToPptDocument(result) {
  const slides = [
    {
      kind: "title",
      title: result.title,
      subtitle: result.curriculumLabel,
    },
    {
      kind: "bullets",
      title: "Simplified Content",
      bullets: result.simplifiedContent ?? [],
    },
    {
      kind: "bullets",
      title: "Key Concepts",
      bullets: result.keyConcepts ?? [],
    },
  ];

  if (result.stepBreakdown?.length > 0) {
    slides.push({
      kind: "bullets",
      title: "Step-by-Step Breakdown",
      bullets: result.stepBreakdown.map(
        (step) => `Step ${step.step}: ${step.title} — ${step.body}`,
      ),
    });
  }

  if (result.examples?.length > 0) {
    slides.push({
      kind: "bullets",
      title: "Examples",
      bullets: result.examples,
    });
  }

  if (result.visuals?.length > 0) {
    slides.push({
      kind: "bullets",
      title: "Visual Aids",
      bullets: result.visuals.map(
        (visual) => `${visual.title}: ${visual.description}`,
      ),
    });
  }

  const filenameBase = `${result.topicLabel} content simplifier`;

  return {
    filename: sanitizeFilename(filenameBase, "content-simplifier"),
    title: result.title,
    subject: result.topicLabel,
    author: "Tema Simplify Content",
    slides,
  };
}
